import React, { Component } from 'react';
import styles from '../../styles/home.module.css';
import HomeContent from './HomeContent'
import { isAuthenticated } from '../../actions/authentication';
import { RenewToken } from '../../utils/token';
import { withNamespaces } from 'react-i18next';
import { withCookies } from 'react-cookie';
import * as keyMenu from '../../scripts/KeyMenu';
import Subscribe from '../pushNotification/Subscribe'

export class Home extends Component {
    constructor(props) {
        super(props)

        this.state = { authenticated: false }

        this.handleTitle();
    }

    componentDidMount() {
        window.history.pushState(null, null, location.href);
        window.onpopstate = function () {
            window.location.reload();
        };

        this.handleToken();
    }

    async handleToken() {
        await RenewToken(this.props);

        isAuthenticated().then((result) => {
            this.setState({ authenticated: result });
        });
    }

    handleTitle() {
        this.props.onLoadTitle('logo');
    }

    handleMessageError(errorMessage) {
        this.props.handleMessageError(errorMessage);
    }

    render() {
        return (
            this.state.authenticated && <div id="divRoot" className={styles.rootHome}>
                <Subscribe />
                <HomeContent handleSelectedPage={this.props.handleSelectedPage} />
            </div>
        );
    }
}

export default withNamespaces(['home'], { wait: true })(withCookies(Home));